import Searchbar from 'app/components/Searchbar'
import React, {useEffect, useState} from 'react'
import db from 'services/firebase'

interface FilterBarProps {
  searchTerm: string
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>
  platforms: string[]
  owners: any[]
  selectedPlatform: string
  setSelectedPlatform: (platform: string) => void
  selectedOwner: string
  setSelectedOwner: (owner: string) => void
  onExport: () => void
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const FilterBar: React.FC<FilterBarProps> = ({
  searchTerm,
  setSearchTerm,
  platforms,
  owners,
  selectedPlatform,
  setSelectedPlatform,
  selectedOwner,
  setSelectedOwner,
  onExport,
  handleInputChange,
}) => {
  const [integration, setIntegration] = useState<any[]>([])

  useEffect(() => {
    getIntegrations()
  }, [])

  const getIntegrations = () => {
    const collectionRef = db.collection('integrations')

    const unsubscribe = collectionRef.onSnapshot((snapshot) => {
      const integrations: any[] = []
      snapshot.forEach((doc) => {
        const data = doc.data()
        integrations.push(data)
      })
      setIntegration(integrations)
    })
  }

  const availableIntegrations = integration
    .filter((item) => platforms.includes(item.name))
    .filter((item, index, self) => index === self.findIndex((t) => t.name === item.name))

  useEffect(() => {
    if (availableIntegrations.length > 0 && !selectedPlatform) {
      setSelectedPlatform(availableIntegrations[0].name)
    }
  }, [availableIntegrations, selectedPlatform, setSelectedPlatform])

  const selectedIntegration = availableIntegrations.find((item) => item.name === selectedPlatform)

  return (
    <div className='card-header border-0 pt-6 h-100'>
      <div className='card-title gap-sm-4'>
        <div className='flex-lg-fill'>
            <Searchbar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        </div>
        <div className='dropdown'>
          <button
            className='btn btn-outline d-flex align-items-center gap-3 px-4 fw-normal'
            type='button'
            id='platformDropdown'
            data-bs-toggle='dropdown'
            aria-expanded='false'
          >
            {selectedIntegration?.img_path && (
              <img
                src={selectedIntegration.img_path}
                alt={selectedIntegration.name}
                style={{width: '18px', height: '18px'}}
              />
            )}
            {selectedPlatform || 'Platform'}
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='20'
              height='20'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              stroke-width='2'
              stroke-linecap='round'
              stroke-linejoin='round'
              className='icon icon-tabler icons-tabler-outline icon-tabler-chevron-down rotate-180'
            >
              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
              <path d='M6 9l6 6l6 -6' />
            </svg>
          </button>
          <ul className='dropdown-menu w-120' aria-labelledby='platformDropdown'>
            {availableIntegrations
              .sort((a, b) => a.name.localeCompare(b.name))
              .filter((item) => item.name !== selectedPlatform)
              .map((item) => (
                <li key={item.name}>
                  <button
                    type='button'
                    className='dropdown-item d-flex align-items-center gap-2'
                    onClick={() => setSelectedPlatform(item.name)}
                  >
                    <img src={item.img_path} alt={item.name} style={{width: '18px', height: '18px'}} />
                    {item.name}
                  </button>
                </li>
              ))}
          </ul>
        </div>

        <div className='dropdown'>
          <button
            className='btn btn-outline px-4 fw-normal'
            type='button'
            id='ownerDropdown'
            data-bs-toggle='dropdown'
            aria-expanded='false'
            style={{color: '#111928'}}
          >
            {selectedOwner || 'Owner'}
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='20'
              height='20'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              stroke-width='2'
              stroke-linecap='round'
              stroke-linejoin='round'
              className='icon icon-tabler icons-tabler-outline icon-tabler-chevron-down rotate-180 ms-2'
            >
              <path stroke='none' d='M0 0h24v24H0z' fill='none' />
              <path d='M6 9l6 6l6 -6' />
            </svg>
          </button>
          <ul className='dropdown-menu' aria-labelledby='ownerDropdown'>
            <li>
              <button type='button' className='dropdown-item' onClick={() => setSelectedOwner('')}>
                All Owners
              </button>
            </li>
            {owners.map((owner) => (
              <li key={owner.id}>
                <button
                  type='button'
                  className='dropdown-item'
                  onClick={() => setSelectedOwner(owner?.full_name)}
                >
                  {owner.full_name}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className='card-toolbar d-flex align-items-center gap-3'>
        <button
          type='button'
          className=' btn btn-sm btn-light me-4 fs-6'
          onClick={onExport}
          style={{height: '40px', background: '#fff', color: '#000', border: '1px solid #C5C5C5'}}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='18'
            height='18'
            viewBox='0 0 24 24'
            fill='none'
            stroke='#5A5A5A'
            stroke-width='2'
            stroke-linecap='round'
            stroke-linejoin='round'
            className='icon icon-tabler icons-tabler-outline icon-tabler-download mb-1 me-2'
            style={{marginRight: '4px'}}
          >
            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
            <path d='M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2' />
            <path d='M7 11l5 5l5 -5' />
            <path d='M12 4l0 12' />
          </svg>
          Export
        </button>
      </div>
    </div>
  )
}

export default FilterBar
